<template>
  <div v-if="loadingPage" class="load-parent" style="z-index: 10">
    <div class="loader"></div>
  </div>

  <LayoutComponent v-if="admin"></LayoutComponent>
  <LayoutManagementComponent v-else></LayoutManagementComponent>

  <div class="fixed-div" v-if="showNewRequest">

    <i @click="showNewRequest = false" class="fa-regular fa-close"></i>

    <NewRequestView :isComponent2="true" @close-modal="showNewRequest = false" :eventData="eventData"/>


  </div>


  <v-snackbar
      v-model="$store.state.snackbar.show"
      :color="$store.state.snackbar.color"
      :timeout="3000"
  >
    {{ $store.state.snackbar.text }}
    <template v-slot:actions>
      <v-btn

          variant="tonal"
          @click="$store.dispatch('snackbar/hide')"
      >
        بستن
      </v-btn>
    </template>
  </v-snackbar>
</template>


<style lang="scss">
.fixed-div {
  position: fixed;
  left: 0;
  background: #fff;
  right: 0;
  width: 100%;
  top: 0;
  height: 100%;
  max-height: 100vh;
  overflow: auto;

  > i {
    font-size: 20px;
    margin: 20px;
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer;
    transition: all ease .4s;

    &:hover {
      opacity: .7;
    }
  }

}

#app {
  width: 100%;
}


</style>
<script setup>
import {ref, computed, onMounted, onBeforeUnmount, watch, defineAsyncComponent} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import Cookies from "js-cookie";
import store from "@/store";
import axios from "axios";
import NewRequestView from "@/views/management/NewRequestView";

const LayoutComponent = defineAsyncComponent(() => import('@/components/admin/Layout'))
const LayoutManagementComponent = defineAsyncComponent(() => import('@/components/management/Layout'))

const route = useRoute()
const router = useRouter()

const apiBaseUrl = window.appConfig.API_URL_BASE
const admin = ref(false)
const loadingPage = ref(false)
const apiInterval = ref('')
const showNewRequest = ref(false)
const userInfo = ref('')
const eventData = ref('')
const active_operator = ref(0)
const headers = {
  'Accept': 'Application/json',
  'Content-Type': 'Application/json',
  'Authorization': 'Bearer ' + Cookies.get('token')
}
const isLogOut = computed(() => store.getters.getLogOut)


const userData = computed(() => store.getters.getUserData)
const roleChange = computed(() => store.getters.getPanelRole)

const startPolling = () => {
  apiInterval.value = setInterval(() => {
    axios.post(apiBaseUrl + 'api/total-functions',
        {token: Cookies.get('token')}, {headers: headers})
        .then(res => {
          let event = res.data.getNewEvents.events[0]
          if (res.data.getNewEvents.total !== 0) {
            showNewRequest.value = true
            eventData.value = event.data
          }
          active_operator.value = res.data.active_operator

          store.commit('setActiveOperator', active_operator.value);
          if (userInfo.value.data.active_operator !== active_operator.value) {
            logout()

          }

        })
        .catch(error => {
          console.error('API error:', error);
        });
  }, 9000);
}


const getPublicSetting = () => {
  let url = apiBaseUrl + 'api/settings/public'
  axios.get(url,
      {headers: headers}).then(res => {
    let title = res.data.data.settings.find(item => item.key === 'title')
    let otp_enabled = res.data.data.settings.find(item => item.key === 'otp_enabled')
    store.commit('setOtpEnabled', otp_enabled.value)

    document.title = title.value


  })
}

const getUserInfo = () => {
  userInfo.value = JSON.parse(localStorage.getItem('userInfo'))
  const panelRole = +localStorage.getItem('panel-role');
  const mainUser = userInfo.value?.data?.main_user;
  const permissionsSystem = userInfo.value?.data?.permissions.some(item => item.category === "system")

  admin.value = (panelRole === 1) && (mainUser === 1 || permissionsSystem);


}

const logout = async () => {
  router.push('/auth/login')
  store.commit('setMobile', '')
  localStorage.removeItem('userInfo')
  localStorage.removeItem('panelRole')
  localStorage.removeItem('panel-role')
  store.commit('setLogin', false);
  removeCookie()
  let url = apiBaseUrl + 'api/logout'
  await axios.post(url, '', {headers: headers}).then(() => {

  }).catch(err => {
    console.log(err)
  })


}
const removeCookie = () => {
  Cookies.remove('token');
}

getUserInfo()
window.appConfig.NODE_ENV === 'production' && startPolling();

onMounted(() => {

  getPublicSetting()

})
onBeforeUnmount(() => {
  clearInterval(apiInterval.value);
})

watch(() => route.name, (newVal) => {
  if (newVal && !admin.value && newVal === 'HomeView') {
    router.push({name: 'DashboardManagement'});
  }
})
watch(() => isLogOut.value, (val) => {
  console.log('val', val)
  if (val) {
    logout()
  }
})
watch(roleChange, (newData) => {
  if (newData == 1) {
    admin.value = true
  } else {
    admin.value = false
  }

})
watch(userData, (newData) => {
  let data = JSON.parse(newData)
  let panelRole = localStorage.getItem('panel-role')
  if (panelRole !== null) {
    if (panelRole == 1 && data?.data?.main_user == 1) {
      admin.value = true
    } else {
      admin.value = false
    }
    return
  }


  if (data?.data?.main_user == 1) {
    admin.value = true
  } else {
    admin.value = false
  }
})
</script>
